import React from 'react'
import ProjectInfo from '../ProjectInfo'

import airplane from "../../../../Assets/images/projects/airplanedetailed.png"


export default function Airplane() {
    return (
        <ProjectInfo pic={airplane}
            title="Flight Stats Estimator"
            maincolor="#2f49a8"
            accentcolor="#d2181f"
            link="https://airplanestats.netlify.app/"
            githublink="https://github.com/Jrwolf99/AirplaneStats"
        >


            <p > This interactive map allows anyone to not only measure
                the distance between any major U.S. airport, but also it provides
                the user with real data on jet fuel expenditures.
            </p>
            <br />
            <p>Created with React, this simulator was developed for those
                curious about how much an airline really pays for their single flight.</p>
            <br />




        </ProjectInfo>
    )
}
